import { useNavigate } from 'react-router-dom'
import TableFilter from './tableFilter'
import ExportButton from '../../common/ExportButton'
import { appGetAllCaste } from '../../store/caste'
import { casteExportColumns } from '../../config/exportColumns/casteExportColumns'
import { useDispatch } from 'react-redux'

function Caste() {
	const navigate = useNavigate()
	const dispatch = useDispatch()
	return (
		<>
			<div className="content-wrapper">
				<div
					className="content-heading d-flex
                          justify-content-between"
				>
					<div>Caste</div>
					<div>
						<ExportButton
							fetchAction={params => dispatch(appGetAllCaste({ ...params, loading: false }))}
							columns={casteExportColumns}
							fileName="Caste_List"
							sheetName="Caste"
							buttonText="Export Caste"
						/>

						<button
							className="btn btn-labeled btn-success"
							type="button"
							style={{ fontSize: '17px', marginLeft: '10px' }}
							onClick={() => navigate('/caste/new')}
						>
							<span className="btn-label">
								<em className="fas fa-plus"></em>
							</span>
							New Caste
						</button>
					</div>
				</div>
				<TableFilter />
			</div>
		</>
	)
}

export default Caste
